export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getSmsList: function getSmsList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/get",
        method: "get",
        params: data
      });
    },
    initSms: function initSms() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/init",
        method: "post",
        data: data
      });
    },
    updateSms: function updateSms() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/update",
        method: "post",
        data: data
      });
    },
    // 获取货币列表
    getSmsCurrencyList: function getSmsCurrencyList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/getCurrencyList",
        method: "get",
        params: data
      });
    },
    // 获取当前城市价格周期
    getSmsPriceByCity: function getSmsPriceByCity() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/getPriceByCity",
        method: "get",
        params: data
      });
    },
    // 添加价格周期
    addSmsPrice: function addSmsPrice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/addPrice",
        method: "post",
        data: data
      });
    },
    // 修改价格周期
    updateSmsPrice: function updateSmsPrice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/updatePrice",
        method: "post",
        data: data
      });
    },
    // 删除价格周期
    deleteSmsPrice: function deleteSmsPrice() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/message_one/deletePrice",
        method: "post",
        data: data
      });
    }
  };
});